export class countUpTimerConfigModel {
    timerClass?:string;
    timerTexts?:timerTexts;
}

export class timerTexts{
    hourText?:string;
    minuteText?:string;
    secondsText?:string;
}